import Evee from 'evee';
import Cookie from 'js-cookie';

import WebBufferCollection from './WebBufferCollection.js';

export default class WebPlayer extends Evee {
    constructor() {
        super();

        this.source = null;


        this.buffers = new WebBufferCollection();
        this.crossfadeTime = 0;
        this.crossfadeTimeout = null;

        // Create audio element
        this.audioElement = document.createElement('audio');
        this.audioElement.style.display = 'none';
        this.audioElement.crossOrigin = 'anonymous';
        document.body.appendChild(this.audioElement);

        // Determine if FLAC is supported
        var flac = this.audioElement.canPlayType('audio/flac');
        this.canPlayFlac = flac == 'probably' || flac == 'maybe';

        // Link up media events
        this._updateTrackMetadataHandler = (e) => this.updateTrackMetadata(e);
        this._trackEndedHandler = (e) => this.trackEnded(e);
        this._trackPausedHandler = (e) => this.trackPaused(e);
        this._trackPlayedHandler = (e) => this.trackPlayed(e);
        this._trackLoadingHandler = (e) => this.updateTrackLoading(e);
        this._trackPositionHandler = (e) => this.updateTrackPosition(e);

        this.addEventHandlers(this.audioElement);
    }

    rotateAudioElement(newAudioElement) {
        console.log('rotateAudioElement');
        newAudioElement.volume = this.audioElement.volume;
        this.removeEventHandlers(this.audioElement);
        this.addEventHandlers(newAudioElement);

        if (this.crossfadeTime) {
            console.log('rotateAudioElement: starting crossfade');
            var crossfadeStart = new Date();
            var oldAudioElement = this.audioElement;
            var startVolume = this.audioElement.volume;
            var interval = setInterval(() => {
                console.log('rotateAudioElement: crossfade interval');
                var deltaTime = (new Date()) - crossfadeStart;
                var volumeOut = (this.crossfadeTime - deltaTime) / this.crossfadeTime;
                var volumeIn = deltaTime / this.crossfadeTime;
                //var volumeIn = deltaTime / (this.crossfadeTime * 0.1);
                //if (volumeIn > 1) {
                //    volumeIn = 1;
                //}

                console.log('volumeIn', volumeIn);
                console.log('volumeOut', volumeOut);

                oldAudioElement.volume = volumeOut * startVolume;
                this.audioElement.volume = volumeIn * startVolume;
            }, 10);

            setTimeout(() => {
                console.log('rotateAudioElement: crossfade timeout');
                clearInterval(interval);
                oldAudioElement.remove();
                this.audioElement.volume = startVolume;
            }, this.crossfadeTime);

        } else {
            this.audioElement.remove();
        }
        this.audioElement = newAudioElement;
    }

    addEventHandlers(audio) {
        audio.addEventListener('durationchange', this._updateTrackMetadataHandler);
        audio.addEventListener('ended', this._trackEndedHandler);
        audio.addEventListener('pause', this._trackPausedHandled);
        audio.addEventListener('play', this._trackPlayedHandler);
        audio.addEventListener('progress', this._trackLoadingHandler);
        audio.addEventListener('timeupdate', this._trackPositionHandler);
    }

    removeEventHandlers(audio) {
        audio.removeEventListener('durationchange', this._updateTrackMetadataHandler);
        audio.removeEventListener('ended', this._trackEndedHandler);
        audio.removeEventListener('pause', this._trackPausedHandled);
        audio.removeEventListener('play', this._trackPlayedHandler);
        audio.removeEventListener('progress', this._trackLoadingHandler);
        audio.removeEventListener('timeupdate', this._trackPositionHandler);
    }

    changeSource(source, track) {
        // this.audioElement.pause();

        console.log({
            buffers: this.buffers,
        });
        try {
            if (this.buffers.hasReadyBuffer(source)) {
                var buffer = this.buffers.getBuffer(source);
                var audioElement = buffer.getAudioElement();
                buffer.releaseAudioElement();
                this.buffers.destroyBuffers(source);

                this.rotateAudioElement(audioElement);
                console.log('WebPlayer changeSource: loaded audio from rotated buffer');
            } else {
                this.audioElement.src = source;
//                var nextAudioElement = document.createElement('audio');
//                nextAudioElement.style.display = 'none';
//                nextAudioElement.crossOrigin = 'anonymous';
//                nextAudioElement.src = source;
//                document.body.appendChild(this.audioElement);
//
//                this.rotateAudioElement(nextAudioElement);
                console.log('WebPlayer changeSource: no preload found');
            }
        } catch (e) {
            console.log('WebPlayer changeSource error', e);
            this.audioElement.src = source;
        }
    }

    prepareNext(source) {
        if (!this.buffers.hasReadyBuffer(source)) {
            this.buffers.makeNewBuffer(source);
        }
    }

    play() {
        console.log('WebPlayer', 'play');
        this.audioElement.play();

        if (!this.audioElement.src) {
            this.audioElement.pause();
        }
        this.emit('playback.start');
    }

    pause() {
        console.log('WebPlayer', 'pause');
        this.audioElement.pause();
        this.emit('playback.pause');
    }

    stop() {
        this.audioElement.pause();
        this.audioElement.src = '';
        this.emit('playback.position', {
            position: 0,
            positionSeconds: 0,
            duration: 0
        });
        this.emit('playback.loading', {
            loaded: 0
        });
    }

    setVolume(amount) {
        console.log('setVolume', amount);
        Cookie.set('pp-volume', amount, { expires: 7 });
        this.audioElement.volume = amount;
    }

    seek(time) {
        this.audioElement.currentTime = time;
    }

    seekPercent(percent) {
        var time = (percent / 100) * this.audioElement.duration;
        this.seek(time);
    }

    getPosition() {
        return this.audioElement.currentTime;
    }





    trackEnded() {
        console.log('trackEnded');
        this.emit('playback.end', {});
    }

    trackPaused() {
        this.emit('playback.pause', {});
    }

    trackPlayed() {
        console.log(this);
        this.emit('playback.start', {});
    }

    updateTrackPosition(e) {
        var remainingTime = this.audioElement.duration - this.audioElement.currentTime;

        if (false && !this.crossfadeTimeout && this.crossfadeTime > 0) {
            if ((remainingTime - 2) * 1000 < this.crossfadeTime) {
                this.crossfadeTimeout = setTimeout(() => {
                    this.crossfadeTimeout = null;
                    this.emit('playback.end');
                }, (this.remainingTime * 1000) - this.crossfadeTime);
            }
        }

        this.emit('playback.position', {
            position: (this.audioElement.currentTime / this.audioElement.duration) * 100,
            positionSeconds: this.audioElement.currentTime,
            duration: this.audioElement.duration
        });
    }

    updateTrackLoading(e) {
        this.emit('playback.loading', {
            loaded: (e.loaded / e.total) * 100
        });
    }


    updateTrackMetadata(e) {
        console.log('updateTrackMetadata', {e});

    }




}



// WEBPACK FOOTER //
// ./src/WebPlayer.js